<template>
    <div class="px-3">
        <div class="row">
            <div class="col-12">
                <div class="d-flex mb-3">
                    <div class="mr-auto d-flex align-items-center">
                        <h5 class="text-dark mb-0">MCP (Model Context Protocol)</h5>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8">
                <el-alert
                    type="success"
                    :closable="false"
                    show-icon
                    class="mb-4">
                    <span>MCP access is enabled for your account. You can connect AI tools such as Claude to your Aloware workspace.</span>
                </el-alert>

                <div class="mb-4">
                    <h6 class="font-weight-bold mb-2">How to connect</h6>
                    <ol class="pl-3">
                        <li class="mb-2">Open your AI tool (e.g. Claude Desktop).</li>
                        <li class="mb-2">Add Aloware as an MCP server using the OAuth connection flow.</li>
                        <li class="mb-2">Authorize the connection when prompted — you'll be asked to sign in to Aloware.</li>
                        <li class="mb-2">Once authorized, your AI tool will have access to Aloware MCP controls.</li>
                    </ol>
                </div>

                <div>
                    <h6 class="font-weight-bold mb-2">Available capabilities</h6>
                    <ul class="pl-3">
                        <li class="mb-1">Send SMS messages</li>
                        <li class="mb-1">Make outbound calls</li>
                        <li class="mb-1">Look up contacts</li>
                        <li class="mb-1">View communication history</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'McpTab',
}
</script>
